<div class="rounded-md border border-slate-700 bg-slate-800/40 p-2">
  <div class="mb-1 text-xs font-semibold text-slate-200">{{ view().title || 'Orders' }}</div>
  @if (view().rows.length === 0) {
    <div class="text-xs text-slate-400">No orders provided.</div>
  } @else {
    <div class="overflow-x-auto">
      <table class="w-full text-left text-xs">
        <thead>
          <tr class="text-slate-400">
            <th class="py-1 pr-2 font-medium">Symbol</th>
            <th class="py-1 pr-2 font-medium">Side</th>
            <th class="py-1 pr-2 font-medium">Qty</th>
            <th class="py-1 pr-2 font-medium">Price</th>
            <th class="py-1 font-medium">Status</th>
          </tr>
        </thead>
        <tbody>
          @for (o of view().rows; track $index) {
            <tr class="border-t border-slate-700/60 text-slate-200">
              <td class="py-1 pr-2 font-mono">{{ o.symbol }}</td>
              <td class="py-1 pr-2">{{ o.side }}</td>
              <td class="py-1 pr-2">{{ o.quantity }}</td>
              <td class="py-1 pr-2">{{ o.price }}</td>
              <td class="py-1">{{ o.status }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>
